import { createRouter, createWebHistory } from 'vue-router'
import defaultLayout from '@/layouts/Default.vue'
import Auth from '@/layouts/Auth.vue'
import authVerify from '@/middlewares/authenticated'
import notAuth from '@/middlewares/notAuthenticated'
import { Dashboard, Devices, Index, Notifications, Alarms, Templates, Admin, DeviceInfo, MonitorUsers, LocationDevices, EditTemplates, Traceability } from "@/views"

const routes = [{

  path: '/',
  component: defaultLayout,
  beforeEnter: authVerify,
  children: [
    {
      path: '/',
      name: 'home',
      component: Index
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/devices',
      name: 'devices',
      component: Devices
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications
    },
    {
      path: '/alarms',
      name: 'alarms',
      component: Alarms
    },
    {
      path: '/templates',
      name: 'templates',
      component: Templates
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/device-info',
      name: 'device-info',
      component: DeviceInfo
    },
    {
      path: '/monitor-users',
      name: 'monitor-users',
      component: MonitorUsers
    },
    {
      path: '/location-devices',
      name: 'location-devices',
      component: LocationDevices
    },
    {
      path: '/edit-templates',
      name: 'edit-templates',
      component: EditTemplates
    },
    {
      path: '/traceability',
      name: 'traceability',
      component: Traceability
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'page404',
      component: () =>
        import( /* webpackChunkName: "page404" */ '@/views/Page404.vue')
    }


  ]
},

{
  path: '/',
  component: Auth,
  beforeEnter: notAuth,
  children: [
    {
      path: '/login',
      name: 'login',
      component: () =>
        import( /* webpackChunkName: "login" */ '@/views/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () =>
        import( /* webpackChunkName: "register" */ '@/views/Register.vue')
    },

    {
      path: '/password-reset',
      name: 'password-reset',
      component: () =>
        import( /* webpackChunkName: "passowrd-reset" */ '@/views/PasswordReset.vue')
    },
    {
      path: '/password-change',
      name: 'password-change',
      component: () =>
        import( /* webpackChunkName: "password-change" */ '@/views/Password-change.vue')
    }

  ]

},

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach(authVerify)


export default router